<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-6 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <BuyFilter
          @apply-filters="HandleApplyFilters"
          @apply-advanced-filters="HandleApplyAdvancedFilters"
        />
        <OverviewBuyCards
          v-if="profitData && BuyData && invoiceData"
          :profit-data="profitData"
          :buy-data="BuyData"
          :invoice-data="invoiceData"
          :duration="changeDurationText"
        />
      </v-container>
      <!--section 2 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--purchase progress -->
          <v-col cols="12" md="6">
            <MonthlyPurchaseProcess
              :filter-chart="filter"
              :advance-filter="advancefilter"
            />
          </v-col>
          <!-- donate buy-->
          <v-col cols="12" md="6">
            <DonateChart :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
      <!--section 3 -->
      <v-container class="pa-0 ma-0">
        <ShoppingByCategory :filter-chart="filter" :advance-filter="advancefilter" />
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import BuyFilter from "./partial/BuyFilter.vue";
import OverviewBuyCards from "./partial/OverviewBuyCards.vue";
import MonthlyPurchaseProcess from "./partial/MonthlyPurchaseProcess.vue";
import DonateChart from "./partial/DonateChart.vue";
import ShoppingByCategory from "./partial/ShoppingByCategory.vue";

export default {
  name: "buy",
  components: {
    BuyFilter,
    OverviewBuyCards,
    MonthlyPurchaseProcess,
    DonateChart,
    ShoppingByCategory,
  },
  data: () => ({
    BuyData: null,
    profitData: null,
    warehouseData: null,
    PurchaseData: null,
    crmData: null,
    CostData: null,
    invoiceData: null,
    loading: false,
    filter: null,
    advancefilter: null,
    changeDurationText: false,
  }),
  mounted() {
    this.getBuyData();
  },
  methods: {
    HandleApplyFilters(filters) {
      this.filter = filters;
      this.getBuyData(filters);
    },
    HandleApplyAdvancedFilters(filters) {
      this.advancefilter = filters;
      this.getBuyData(filters);
    },
    getBuyData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "month";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/invoice-kpi", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data;
          app.BuyData = res.sumPurchase;
          app.profitData = res.totalProfit;
          app.invoiceData = res.invoiceSum;
          app.changeDurationText = res.flag;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>
